import { render } from "./PrimaryButton.vue?vue&type=template&id=82da5da6&scoped=true&ts=true&lang=pug"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts"

import "./PrimaryButton.vue?vue&type=style&index=0&id=82da5da6&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82da5da6"]])

export default __exports__